export function formatInteger(input: number, offset: number, length: number) {
	return String(input + offset).padStart(length, '0');
}
